import action from '../../../abstract/action.js';
import api from '../api';

export default action({
  label: 'Usuń',
  icon: 'TrashIcon',
  main: () => false,
  handle: async ({ $vs, item: { id } }) => {
    $vs.loading();
    await api.softDelete(id).finally(() => $vs.loading.close());
  },
});
